export class SaleOrderControlDocument {
  constructor(
      public hash?: string,
      public saleOrderHash?: string,
      public date?: number,
      public transportOperator?: string,
      public carrier?: string,
      public enrollment?: string,
      public trailer?: string,
      public observation?: string,
      public viewLogoInPdf?: string,
      public packingUnits?: number
  ) { }

  clone() {
    return new SaleOrderControlDocument(
        this.hash,
        this.saleOrderHash,
        this.date,
        this.transportOperator,
        this.carrier,
        this.enrollment,
        this.trailer,
        this.observation,
        this.viewLogoInPdf,
        this.packingUnits
    );
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/sale-order-control-document.ts